import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  id: string;
}
export const useSetCustomsControl = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: HookProps) => {
      const result = await apiClient.declarationsCrud.setCustomsControl.mutation({
        params: { id },
        body: undefined,
      });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.id] });
      toast.success('Declaration updated!');
    },
    onError: (error) => {
      showErrorToast(error, `Error updating the declaration!`);
    },
  });
};
